import React from "react";

import Table from "../../common/Table";

import { Link } from "react-router-dom";

const BudgetListTable = ({ data, query }) => {
  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "name",
      label: "نام",
      content: (e) => (
        <Link to={`/mis/revenueBudgets/accounts/${e.id}`}>{e.name}</Link>
      ),
    },
    { path: "revenue_type", label: "حوزه درآمد" },
    { path: "budget", label: "بودجه" },
    { path: "paid", label: "پرداخت شده" },
    { path: "balance", label: "باقیمانده" },
    { path: "option" },
  ];

  return <Table data={data} columns={columns} query={query} />;
};

export default BudgetListTable;
